import { useCallback, useMemo } from "react";
import { generatePdfAndWaitForDeclaration } from "./waitForRecordGeneration";

/**
 * Hook wrapper for record-generation Pusher progress (finalize & send flow).
 */
export function useRecordGenerationProgress() {
  const generateAndWait = useCallback(
    ({ orderId, requestGeneratePdf, onProgress, timeoutMs }) =>
      generatePdfAndWaitForDeclaration({
        orderId,
        requestGeneratePdf,
        onProgress,
        timeoutMs,
      }),
    [],
  );

  return useMemo(
    () => ({
      generateAndWait,
    }),
    [generateAndWait],
  );
}

export default useRecordGenerationProgress;
